import { useEffect, useState } from 'react'
import api from './api.js'

// Module-level cache: /countries is static, fetch once per session.
let cache = null
let inflight = null

export function useCountries() {
  const [countries, setCountries] = useState(cache || [])
  useEffect(() => {
    if (cache) { setCountries(cache); return }
    if (!inflight) inflight = api.get('/countries').then(({ data }) => { cache = data?.countries || []; return cache })
    inflight.then((c) => setCountries(c)).catch(() => setCountries([]))
  }, [])
  return countries
}
